import { JsonObject, JsonProperty } from 'json2typescript';
import { UserCurrencyType } from '../../enums/users/user-currency-type.enum';

@JsonObject('UserCurrency')
export class UserCurrency {

  @JsonProperty('currency_type', Number)
  currencyType: UserCurrencyType = UserCurrencyType.None;

  @JsonProperty('currency_quantity', Number)
  currencyQuantity: number = 0;

  @JsonProperty('currency_ticket_cost', Number)
  currencyTicketCost: number = 0;
}
